import React from 'react';

import { UserFormData } from '../../../interfaces/userForm';
import AdminUserManagementCreateForm from './AdminUserManagementCreateForm';

const createUserFormState: UserFormData = {
    email: '',
    first_name: '',
    last_name: '',
    programs: [],
    regions: [],
    vias_roles: [],
};

const AdminUserManagementCreate = () => (
    <AdminUserManagementCreateForm createUserFormState={createUserFormState} />
);

export default AdminUserManagementCreate;
